import React from 'react';
import { getTheme } from '@uifabric/styling';
import { DocumentCardType, Stack } from 'office-ui-fabric-react';
import { formatDateTime } from 'buzz_lib_shared';
import { UpstreamModulePatchType } from './types/UpstreamModulePatchType';
import { DocumentCard } from '../DocumentCard';
import { DocumentCardActivity } from '../DocumentCard/DocumentCardActivity';
import { DocumentCardDetails } from '../DocumentCard/DocumentCardDetails';
import { DocumentCardPreview } from '../DocumentCard/DocumentCardPreview';
import { DocumentCardTitle } from '../DocumentCard/DocumentCardTitle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const defaultCreateUpdatedByText = updatedBy => {
  if (updatedBy.Username.startsWith(UpstreamModulePatchType.Cl)) return 'Content Library change';
  if (updatedBy.Username.startsWith(UpstreamModulePatchType.Programming)) return 'Programming change';
  return updatedBy.Username;
};
export const OrderChangeHistoryCard = _ref => {
  let {
    item,
    createUpdatedByText = defaultCreateUpdatedByText
  } = _ref;
  const {
    palette,
    fonts
  } = getTheme();
  const getValueText = value => !value ? 'empty value' : value;
  const createDocumentCardTitle = () => {
    const cardTitle = "".concat(item.ChangeType, " change from ").concat(getValueText(item.OldValue), " to ").concat(getValueText(item.NewValue));
    if (item.ChangeScope) return cardTitle + " for ".concat(item.ChangeScope);
    return cardTitle;
  };
  const createStatusChangeText = () => {
    const isStatusChanged = item.OldStatus !== item.NewStatus;
    if (!isStatusChanged) return 'No Status change';
    return "Status Change: ".concat(item.OldStatus, " \u2192 ").concat(item.NewStatus);
  };
  const documentCardActivityStyles = {
    avatar: {
      display: 'none'
    },
    avatars: {
      height: 16
    },
    details: {
      left: 'unset',
      display: 'flex',
      flexDirection: 'row',
      '& > *:not(:first-child)': {
        marginLeft: 5
      }
    },
    name: {
      height: 16
    }
  };
  const historyIconWidthInPx = 35;
  const historyCardChildrenGapInPx = 16;
  return /*#__PURE__*/_jsx(Stack, {
    styles: {
      root: {
        paddingTop: 5
      }
    },
    children: /*#__PURE__*/_jsx(DocumentCard, {
      type: DocumentCardType.compact,
      "data-id": "".concat(item.Id, "-change-history-item"),
      styles: {
        root: {
          maxWidth: '100%',
          height: 92
        }
      },
      children: /*#__PURE__*/_jsxs(DocumentCardDetails, {
        children: [/*#__PURE__*/_jsxs(Stack, {
          horizontal: true,
          verticalAlign: "center",
          styles: {
            root: {
              paddingTop: 16,
              paddingLeft: 16
            }
          },
          tokens: {
            childrenGap: historyCardChildrenGapInPx
          },
          children: [/*#__PURE__*/_jsx(DocumentCardPreview, {
            styles: {
              previewIcon: {
                backgroundColor: palette.white,
                width: historyIconWidthInPx
              },
              root: {
                borderRight: 'none !important',
                flexShrink: '0 !important'
              }
            },
            previewImages: [{
              previewIconProps: {
                iconName: 'FullHistory',
                styles: {
                  root: {
                    fontSize: fonts.xLarge.fontSize,
                    color: palette.themePrimary
                  }
                }
              }
            }]
          }), /*#__PURE__*/_jsxs(Stack, {
            styles: {
              root: {
                maxWidth: "calc(100% - ".concat(historyIconWidthInPx, "px - ").concat(historyCardChildrenGapInPx, "px)")
              }
            },
            children: [/*#__PURE__*/_jsx(DocumentCardTitle, {
              styles: {
                root: {
                  fontWeight: '500',
                  marginLeft: '0px !important',
                  lineHeight: 'normal !important',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  '-webkit-line-clamp': '1',
                  '-webkit-box-orient': 'vertical',
                  padding: 0,
                  height: '20px'
                }
              },
              title: createDocumentCardTitle()
            }), /*#__PURE__*/_jsx(DocumentCardTitle, {
              styles: {
                root: {
                  height: '20px',
                  fontWeight: '200',
                  width: '100%',
                  marginLeft: '0px !important',
                  padding: 0
                }
              },
              title: createStatusChangeText()
            })]
          })]
        }), /*#__PURE__*/_jsx(DocumentCardActivity, {
          styles: documentCardActivityStyles,
          activity: formatDateTime(new Date(item.UpdateDate)),
          people: [{
            name: "Updated by ".concat(createUpdatedByText(item.UpdatedBy, defaultCreateUpdatedByText)),
            profileImageSrc: ''
          }]
        })]
      })
    })
  }, item.Id);
};